export const PIXEL_ID = '1565972794674204'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initPixel = () => {
  // Only run in browser environment
  if (typeof window === 'undefined') return

  // Check if pixel is already loaded
  if (window.fbq) return

  // Create fbq function
  const fbq: any = function () {
    fbq.callMethod
      ? fbq.callMethod.apply(fbq, arguments)
      : fbq.queue.push(arguments)
  }

  if (!window._fbq) window._fbq = fbq
  window.fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  // Load the Facebook Pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  }

  // Initialize pixel with ID
  fbq('init', PIXEL_ID)
  fbq('track', 'PageView')

  // Add noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  console.log('✅ Meta Pixel inicializado con ID:', PIXEL_ID)
}

export const trackPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
    console.log('📊 Meta Pixel: PageView tracked')
  }
}

export const trackEvent = (eventName: string, data = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, data)
    console.log('📊 Meta Pixel event:', eventName, data)
  }
}

export const trackCustomEvent = (eventName: string, data = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, data)
    console.log('📊 Meta Pixel custom event:', eventName, data)
  }
}
